var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconPlayerPlayFilled = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0544 9.77437C20.3731 10.547 20.3731 12.4532 19.0544 13.2258L8.01097 19.6954C6.67768 20.4764 5 19.515 5 17.9698V5.03037C5 3.48512 6.67768 2.5236 8.01097 3.30469L19.0544 9.77437Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconPlayerPlayFilled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/IconPlayerPlayFilled.a5505b1bd534f1eecefed9b9bef436e1.svg";